import { Navigate } from 'react-router-dom';

import { FCC, useToast } from '@eluve/components';
import { useSession } from '@eluve/session-helpers';

export const PromptsGuard: FCC = ({ children }) => {
  const session = useSession();
  const toast = useToast();

  if (!session.isPromptTemplateCreator) {
    toast.error('Access denied');
    return <Navigate to="/" replace />;
  }

  return children;
};
